import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";
import { BookkeepingListItem } from "./MultiBookkeepingList";

interface Props extends PickerListProps<server.dto.BookkeepingSmall> {
  securityScope: server.dto.BookkeepingSecurityScopes;
}

const BookkeepingList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListBookkeepingInstruction>({
    keyword: "",
    page: 1,
    perPage: 20,
    visible: "onlyYes"
  });

  return <PickerList
    instruction={instruction}
    onInstructionChange={newInstruction => setInstruction(newInstruction)}
    queryKey="bookkeepinglist"
    api={instruction => window.CoreApi.Bookkeeping.PaginatedSmall(instruction, props.securityScope)}
    onClick={props.onItemSelected}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={bookkeeping => bookkeeping.bookkeepingId}
    renderListItem={BookkeepingListItem}
  />;
};

export default BookkeepingList;